import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locales/en.json';
import es from './locales/es.json';
import ca from './locales/ca.json';
import bg from './locales/bg.json';
import da from './locales/da.json';
import de from './locales/de.json';
import el from './locales/el.json';
import fr from './locales/fr.json';
import hi from './locales/hi.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import zh from './locales/ch.json'; 
import ar from './locales/ar.json';

import { getInitialLocale } from './getInitialLocale';

Vue.use(VueI18n);

const messages = {
  en,
  es,
  ca,
  bg,
  da,
  de,
  el,
  fr,
  hi,
  it,
  ja,
  pt,
  ru,
  zh,
  ar,
};

const initialLocale = getInitialLocale();

export default new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  messages,
});